module.exports = __webpack_public_path__ + "img/pr-21.4dbdaab1.png";